import React, { type ReactNode } from 'react';
import { Offscreen, Step, Stepper } from '@deque/cauldron-react';
import { useTranslation } from 'react-i18next';
import { getOffscreenStepStatus } from '../../common/utils/get-step-status';

interface Props {
  completedSteps: number;
  steps: ReactNode[];
}

const WalkthroughStepper = ({ completedSteps, steps }: Props) => {
  const { t } = useTranslation();

  return (
    <Stepper>
      {steps.map((step, index) => {
        const status =
          completedSteps === index
            ? 'current'
            : completedSteps < index
            ? 'future'
            : 'complete';

        const offscreenStepStatus = getOffscreenStepStatus(t, status);

        return (
          <Step key={`${step}-${index}`} status={status}>
            {step} <Offscreen>{offscreenStepStatus}</Offscreen>
          </Step>
        );
      })}
    </Stepper>
  );
};

export default WalkthroughStepper;
